var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-list"
  }, [_c('Layout', [_c('Phead')], 1), _c('Apps', {
    on: {
      "on-jump": _vm.jump
    }
  }), _c('UnitSelect', {
    ref: "UnitSelect"
  }), _c('OpenAppModal', {
    ref: "OpenAppModal"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };